var svgSourcePrint = {
    props: {
        src: {
            type: String,
            default: "",
        },
    },
    template: `<i class="e-svg-source-print" v-html="imgSrc"></i>`,
    data() {
        return {
            imgSrc: "",
        };
    },
    mounted() {
        this.getSource();
    },
    methods: {
        getSource() {
            if (this.src !== "") {
                fetch(this.src).then((resp) => {
                    if (resp.ok) {
                        resp.text().then((txt) => {
                            this.imgSrc = String(txt);
                        });
                    }
                });
            }
        },
    },
};
